module.exports = __webpack_public_path__ + "img/i.81ba8639.jpg";